/* @jsxImportSource react */

import type { FragmentType } from '@packages/gql/generated/shopping';
import type { ProductDataSheetsDownloadsListFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductDataSheetsDownloadsListFragmentFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';
import { DownloadItem } from '../DownloadItem/DownloadItem.client';

/* GraphQL */ `
  fragment ProductDataSheetsDownloadsListFragment on Product {
    productDataSheetsDownloads: downloads(type: PRODUCT_DATASHEET) {
      type
      link
    }
  }
`;

export type ProductDataSheetsDownloadsListProps = {
  data: FragmentType<typeof ProductDataSheetsDownloadsListFragmentFragmentDoc>;
};

export const ProductDataSheetsDownloadsList = ({ data }: ProductDataSheetsDownloadsListProps) => {
  const { productDataSheetsDownloads } =
    unmask<typeof ProductDataSheetsDownloadsListFragmentFragmentDoc>(data);

  if (productDataSheetsDownloads.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col items-center gap-1.5">
      {productDataSheetsDownloads.map(({ type, link }, index) => (
        <DownloadItem
          renderIcon={false}
          type={type}
          link={link}
          // index should only be shown, if there is more then one download
          linkTextExtension={productDataSheetsDownloads.length > 1 ? index + 1 : undefined}
          // eslint-disable-next-line react/no-array-index-key
          key={index}
        />
      ))}
    </div>
  );
};
